import { Injectable } from '@angular/core';

@Injectable()
export class AppInitService {

    public onInit(): void {
        // do nothing
    }
}
